import { render } from "./PR22-01272023.vue?vue&type=template&id=38f33e46"
import script from "./PR22-01272023.vue?vue&type=script&lang=js"
export * from "./PR22-01272023.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__